import React, { useState } from "react";
import { Modal } from "antd";
import { CloseOutlined } from '@ant-design/icons';


const ModalStandard = ({
    modalButton,
    extraClass = "",
    maskClosable = true,
    closable = true,
    defaultShow = false,
    disabled = false,
    width = 380,
    onOpen = () => { },
    onCancel = () => { },
    dialogTitle,
    dialogLabelledBy,
    modalRender,
    ...props
}) => {

    const [ showModal, setShowModal ] = useState(defaultShow);
    const renderModal = dialogLabelledBy || modalRender ? (modal) => {
        const renderedModal = modalRender ? modalRender(modal) : modal;

        if (!dialogLabelledBy || !React.isValidElement(renderedModal)) return renderedModal;

        const renderedRef = renderedModal.ref;

        return React.cloneElement(renderedModal, {
            ref: (node) => {
                if (typeof renderedRef === "function") renderedRef(node);
                else if (renderedRef) renderedRef.current = node;

                node?.closest("[role='dialog']")?.setAttribute(
                    "aria-labelledby",
                    dialogLabelledBy
                );
            },
        });
    } : undefined;

    return (
        <>
            { modalButton && React.cloneElement(modalButton, {
                disabled,
                onClick: (event) => {
                    modalButton.props.onClick?.(event);
                    onOpen(event);
                    setShowModal(true);
                }
            }) }
            <Modal
                className={ `modal-standard ${ extraClass }` }
                centered
                visible={ showModal }
                maskClosable={ maskClosable }
                width={ width }
                closable={ closable }
                closeIcon={ <CloseOutlined /> }
                title={ dialogTitle }
                modalRender={ renderModal }
                destroyOnClose={ true }
                footer={ null }
                onOk={ () => setShowModal(false) }
                onCancel={ (event) => {
                    onCancel(event);
                    setShowModal(false)
                } }
            >
                { Array.isArray(props.children) ?
                    props.children.map(
                        (child, index) => React.cloneElement(child, { key: index, action: () => setShowModal(false) })
                    ) :
                    React.cloneElement(props.children, { action: () => setShowModal(false) })
                }

            </Modal>
        </>
    );
}

export default ModalStandard;

